"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation Register($user: UserInput!) {
    register(user: $user) {
      registered
      emailVerified
      userProfile {
        user {
          _id
          firstName
          lastName
          phoneNumber
          email
          preferredLogin
          orgContextId
          role {
            role
          }
        }
        stripeCustomerId
        stripeCustomer {
          paymentMethods {
            paymentMethodId
            brand
            last4
            expMonth
            expYear
            funding
            country
            type
          }
        }
      }
    }
  }
`;
exports.default = mutation;
//# sourceMappingURL=register.mutation.js.map